var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3839 58.105C49.3839 56.6316 48.1895 55.4371 46.716 55.4371H34.5892C33.1158 55.4371 31.9213 56.6316 31.9213 58.105C31.9213 59.5784 33.1158 60.7729 34.5892 60.7729H46.716C48.1895 60.7729 49.3839 59.5784 49.3839 58.105ZM57.9473 71.3206C57.9473 68.2397 55.4497 65.7421 52.3688 65.7421H20.8392C16.9547 65.7421 13.8057 68.8911 13.8057 72.7756C13.8057 76.6602 16.9547 79.8092 20.8392 79.8092H28.1152C30.6604 79.8092 32.7236 81.8724 32.7236 84.4176C32.7236 86.9627 34.7868 89.0259 37.332 89.0259H64.4958C67.8446 89.0259 70.5592 86.3112 70.5592 82.9625C70.5592 79.6138 67.8446 76.8991 64.4958 76.8991H63.5258C60.4449 76.8991 57.9473 74.4015 57.9473 71.3206ZM87.7165 85.7179C87.7165 82.4081 90.3996 79.7251 93.7093 79.7251H105.695C109.005 79.7251 111.688 82.4081 111.688 85.7179C111.688 89.0276 109.005 91.7106 105.695 91.7106H93.7093C90.3996 91.7106 87.7165 89.0276 87.7165 85.7179Z",
    fill: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49277 101.102C45.7494 98.9727 82.7233 98.5624 121.507 100.467",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3365 93.1153L30.6087 99.2464H83.4783L77.6039 86.3029C76.452 82.6696 72.7085 76.5793 72.7085 76.5793L67.8132 67.7096C67.8132 67.7096 62.9179 59.8254 58.0226 56.8689C52.6575 53.6286 52.4757 57.5247 49.211 60.811C45.2947 64.7531 41.3784 71.6517 41.3784 71.6517L37.4622 79.5359L34.4098 86.3029C34.4098 86.3029 32.7972 91.4122 32.3365 93.1153Z",
    fill: "white",
    stroke: "#1A202C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_133_2219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 54,
    width: 56,
    height: 47
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9917 93.1428L30.2591 99.3136H83.2765L77.3857 86.2863C76.2306 82.6295 72.4767 76.4998 72.4767 76.4998L67.5676 67.5726C67.5676 67.5726 62.6586 59.6374 57.7496 56.6617C52.3695 53.4005 52.1872 57.3218 48.9133 60.6293C44.9861 64.5969 41.0589 71.5402 41.0589 71.5402L37.1317 79.4755L34.0708 86.2863C34.0708 86.2863 32.4537 91.4287 31.9917 93.1428Z",
    fill: "#76CAFB",
    stroke: "#1A202C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_133_2219)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2591 99.3136L32.0183 93.1428C32.4875 91.4287 34.1294 86.2863 34.1294 86.2863L37.2375 79.4755L41.2251 71.5402C41.2251 71.5402 45.2128 64.5969 49.2004 60.6293C50.0459 59.7881 50.6883 58.9072 51.2661 58.1148C52.9602 55.7917 54.0992 54.2299 58.1726 56.6617C59.9072 57.6972 61.6418 59.3333 63.1663 61.0266C62.8014 61.5215 62.3962 62.0294 61.923 62.5233C58.1951 66.4143 54.4673 73.2236 54.4673 73.2236L50.7395 81.0056L47.8339 87.6849C47.8339 87.6849 46.299 92.728 45.8604 94.409L44.5275 99.3136H30.2591Z",
    fill: "#E2E8F0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3365 93.1153L30.6087 99.2464H83.4783L77.6039 86.3029C76.452 82.6696 72.7085 76.5793 72.7085 76.5793L67.8132 67.7096C67.8132 67.7096 62.9179 59.8254 58.0226 56.8689C52.6575 53.6286 52.4757 57.5247 49.211 60.811C45.2947 64.7531 41.3784 71.6517 41.3784 71.6517L37.4622 79.5359L34.4098 86.3029C34.4098 86.3029 32.7972 91.4122 32.3365 93.1153Z",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_133_2219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 71,
    width: 35,
    height: 30
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7117 95.488C69.429 96.5507 68.6513 99.3136 68.6513 99.3136H101.102C101.102 99.3136 98.203 93.5044 97.496 91.2374C96.789 88.9704 94.4913 85.1703 94.4913 85.1703L91.4867 79.6359C91.4867 79.6359 88.482 74.7165 85.4774 72.8718C82.1844 70.85 80.069 75.3315 80.069 75.3315L75.2615 81.8859L72.8578 87.0151C72.8578 87.0151 71.4085 90.1747 70.9843 91.2374C70.645 92.0875 69.9945 94.4254 69.7117 95.488Z",
    fill: "#76CAFB",
    stroke: "#1A202C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_133_2219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7117 95.488C69.429 96.5507 68.6513 99.3136 68.6513 99.3136H101.102C101.102 99.3136 98.203 93.5044 97.496 91.2374C96.789 88.9704 94.4913 85.1703 94.4913 85.1703L91.4867 79.6359C91.4867 79.6359 88.482 74.7165 85.4774 72.8718C82.1844 70.85 80.069 75.3315 80.069 75.3315L75.2615 81.8859L72.8578 87.0151C72.8578 87.0151 71.4085 90.1747 70.9843 91.2374C70.645 92.0875 69.9945 94.4254 69.7117 95.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8453 98.9691L68.9904 95.2258C69.2957 94.186 70.3645 91.0666 70.3645 91.0666L72.388 86.9349L74.9843 82.121C74.9843 82.121 77.5807 77.9089 80.1775 75.5017C80.728 74.9913 81.1464 74.4569 81.5226 73.9762C82.6257 72.5669 83.3674 71.6193 86.0209 73.0938C87.0983 73.6925 88.1758 74.6225 89.1346 75.5979C86.5512 78.0077 84.0088 82.062 84.0088 82.062L81.3831 86.8477L79.3366 90.9551C79.3366 90.9551 78.2557 94.0562 77.9469 95.09L76.7888 98.8113L102.832 98.8058L102.909 98.9617L67.8453 98.9691Z",
    fill: "#E2E8F0"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7971 34.3188C53.8732 38.0607 54.7247 41.729 54.7247 45.4819C54.7247 48.5617 54.6665 51.645 54.7247 54.7246",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7751 34.4523C56.5315 34.5487 55.2074 34.4869 55.2074 34.4869C55.2074 34.4869 53.4923 34.3003 53.4275 34.4909C53.2819 34.9187 53.3537 36.007 53.3537 36.007L53.7528 40.4978C53.7528 40.4978 53.6652 42.5991 53.6304 43.4055L53.5319 45.6883C53.4991 46.448 54.2876 46.2127 54.8892 46.0782C56.0814 45.8117 58.7467 45.6952 58.7467 45.6952C58.7467 45.6952 64.8161 45.7876 67.7699 45.6006C69.2177 45.5089 70.6365 45.4475 72.0736 45.2368C72.4797 45.1772 72.736 45.1762 72.3871 44.8786C71.9773 44.529 71.0494 43.843 71.0494 43.843C71.0494 43.843 69.4074 42.4242 68.2369 41.685C67.0227 40.9182 65.6707 40.1144 64.7102 39.4741C64.5178 39.3829 63.3013 38.783 63.7482 38.565C65.0111 37.9489 66.0486 37.0517 67.2792 36.3495C68.4087 35.7049 69.598 35.1281 70.6975 34.4444C70.9642 34.2785 71.7281 34.1817 71.0164 34.151C68.8308 34.0567 66.6195 34.1725 64.4371 34.3034C62.2143 34.4368 60.0004 34.2796 57.7751 34.4523Z",
    fill: "#E2E8F0",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6986 95.4303C69.4157 96.4903 68.6377 99.2464 68.6377 99.2464H101.101C101.101 99.2464 98.2016 93.4517 97.4944 91.1903C96.7871 88.9289 94.4885 85.1383 94.4885 85.1383L91.4826 79.6178C91.4826 79.6178 88.4767 74.7106 85.4708 72.8704C82.1764 70.8537 80.0601 75.324 80.0601 75.324L75.2507 81.8622L72.846 86.9785C72.846 86.9785 71.3961 90.1303 70.9717 91.1903C70.6322 92.0383 69.9815 94.3703 69.6986 95.4303Z",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.692 30.0285C74.9158 29.0467 76.1476 28.0812 77.3901 27.1312",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6037 33.7554C77.9337 33.4381 79.8218 33.4352 81.0608 32.8124",
    stroke: "#A0AEC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.f135e87510a40b16499e3473cdf7d030.svg";
export { ForwardRef as ReactComponent };